export default __webpack_public_path__ + "1929084.png";